const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const CCHandler = require('../../CCHandler');
const LoseMPEvent = require('../../events/LoseMPEvent');
const { logError } = require('../../logger');

const SleightOfHand = function (battleState) {
  this.handle = 'sleight_of_hand';
  this.magic = true;
  this.ranged = true;
  this.harm = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = () => true;

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    setTimeout(() => {
      try {
        if (
          !actor ||
          !actor.inPlay ||
          !victim ||
          (victim.unit && !victim.inPlay)
        ) {
          return;
        }

        var success = false;
        var loseMP;

        const reflected = BattleCalc.rollForReflectMagic(victim);
        const finalActor = reflected ? victim : actor;
        const finalVictim = reflected ? actor : victim;

        if (!CCHandler.checkForResistMental(finalVictim, battleState)) {
          var finalPotency = Math.floor(
            BattleCalc.getEquippedAbility(actor, 'sleight_of_hand').potency
          );
          if (finalPotency > finalVictim.mp) {
            finalPotency = finalVictim.mp;
          }

          loseMP = new LoseMPEvent(battleState, finalPotency);
          loseMP.execute(finalVictim);
          loseMP.actorId = finalActor.uid;
          loseMP.victimId = finalVictim.uid;

          success = true;
        }

        var result = { success, loseMP };
        result.abilityHandle = this.handle;
        result.actorId = finalActor.uid;
        result.victimId = finalVictim ? finalVictim.uid : null;
        result.is_reflection = reflected;
        result.allPieces = battleState.allPieces;
        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'sleight_of_hand',
          func: 'execute',
          actor: JSON.stringify(actor),
          victim: JSON.stringify(victim),
        });
      }
    }, BattleCalc.getCooldown(actor) * 0.5);
  };
};
module.exports = SleightOfHand;
